import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import WalletIcon from "@mui/icons-material/Wallet";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { COLORS } from "../../constants";

const MobileFaq = ({
  sections,
  expandedFaq,
  handleSectionClick,
  accordionRefs,
  sanitizedData,
}) => (
  <Container sx={{ mt: 4, mb: 4 }} disableGutters>
    <Typography
      sx={{
        paddingLeft: 0,
        backgroundColor: "none",
        fontSize: "var(--font-size-xs)",
        fontWeight: 400,
        my: 2,
      }}
    >
      Popular topics
    </Typography>
    <Box
      sx={{
        display: "flex",
        gap: 2,
        mb: 6,
        width: "100%",
        overflowX: "auto",
        scrollSnapType: "x mandatory",
        "-webkit-overflow-scrolling": "touch",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        scrollbarWidth: "none",
      }}
    >
      {sections.map((section, index) => (
        <Button
          key={index}
          variant="outlined"
          onClick={() =>
            handleSectionClick(index, section.sectionContent[0].key)
          }
          sx={{
            backgroundColor: COLORS.white,
            border: `1px solid ${COLORS.border}`,
            borderRadius: "2px",
            textAlign: "center",
            p: 2,
            "&:hover": {
              borderTopColor: COLORS.themeRed,
              borderTopWidth: "2px",
            },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            flex: "0 0 70%", // Show approximately 1.4 slides
            scrollSnapAlign: "start",
            minWidth: "70%", // Ensure consistent sizing
          }}
        >
          <Box
            sx={{
              borderRadius: "50%",
              p: 2,
              backgroundColor: COLORS.themeYellow,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1,
            }}
          >
            {index === 0 && (
              <LocalShippingIcon
                sx={{ fontSize: 20, color: COLORS.darkText }}
              />
            )}
            {index === 1 && (
              <WalletIcon sx={{ fontSize: 20, color: COLORS.darkText }} />
            )}
            {index === 2 && (
              <AssignmentReturnIcon
                sx={{ fontSize: 20, color: COLORS.darkText }}
              />
            )}
            {index === 3 && (
              <PhoneInTalkIcon sx={{ fontSize: 20, color: COLORS.darkText }} />
            )}
          </Box>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "var(--font-size-xs)",
              color: COLORS.darkText,
            }}
          >
            {section.heading}
          </Typography>
          <Typography
            sx={{
              fontSize: "var(--font-size-xxs)",
              color: COLORS.lightText,
            }}
          >
            {index === 0 &&
              "What are the shipping options available for orders from Argus?"}
            {index === 1 && "What payments methods are available at Argus?"}
            {index === 2 && "How do I return or exchange an item?"}
            {index === 3 &&
              "How can I contact the Argus customer support team?"}
          </Typography>
        </Button>
      ))}
    </Box>
    {sections.map((section, sectionIndex) => (
      <Box key={sectionIndex} sx={{ mb: 6 }}>
        <Typography
          variant="h5"
          sx={{
            mb: 2,
            fontWeight: "500",
            fontSize: "var(--font-size-l)",
            color: COLORS.darkText,
          }}
        >
          {section.heading}
        </Typography>
        {section.sectionContent.map((faq, faqIndex) => (
          <Accordion
            key={faq.key}
            ref={(el) =>
              (accordionRefs.current[`${sectionIndex}-${faq.key}`] = el)
            }
            expanded={expandedFaq === `${sectionIndex}-${faq.key}`}
            onChange={() => handleSectionClick(sectionIndex, faq.key)}
            sx={{
              mb: 2,
              boxShadow: "none",
              p: 1,
              borderRadius: "2px",
              border: `1px solid ${COLORS.border}`,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${faqIndex}-content`}
              id={`panel${faqIndex}-header`}
              sx={{
                color: COLORS.darkText,
                fontSize: "var(--font-size-xxl)",
              }}
            >
              <BookmarkIcon
                sx={{
                  fontSize: "var(--font-size-s)",
                  position: "absolute",
                  top: -11,
                  left: 15,
                  color: COLORS.themeRed,
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  mt: 1,
                  fontSize: "var(--font-size-xs)",
                }}
              >
                {faq.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                color="textSecondary"
                dangerouslySetInnerHTML={sanitizedData(faq.content)}
                sx={{
                  fontSize: "var(--font-size-xs)",
                }}
              />
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    ))}
  </Container>
);

export default MobileFaq;
